import React from "react"
import "./perks.css"

export default props => {
  return (
    <div id="perk-container">
      <div id="image-holder">
        <img src={props.image} alt="perks-example" />
      </div>
      <div id="perk-text">
        <h4>{props.title}</h4>
        <p>{props.text}</p>
      </div>
    </div>
  )
}
